import { useCallback, useState } from 'react';
import { useSnackbar } from 'notistack';
import { SsoService, TenantDiscoveryResponse } from 'api';
import { Logger } from 'utilities';

const useSSO = () => {
  const [isSSOMode, setIsSSOMode] = useState(true);
  const { enqueueSnackbar } = useSnackbar();

  const discoverTenantByEmail = useCallback(
    async (email: string) => {
      try {
        const response = await SsoService.apiSsoDiscoverCreate({ email });
        if (response.post_discovery_flow === TenantDiscoveryResponse.post_discovery_flow.SAML) {
          // browser redirect to SSO login URL
          window.location.href = response.login_url as string;
        } else {
          setIsSSOMode(false);
        }
      } catch (error) {
        Logger.error('Error discovering tenant for SSO.', error);
        enqueueSnackbar('Error discovering tenant for SSO.', { variant: 'error' });
        setIsSSOMode(false);
      }
    },
    [enqueueSnackbar]
  );

  return { isSSOMode, discoverTenantByEmail, setIsSSOMode };
};

export default useSSO;
